import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
import { IRechnung, IRechPos } from '../../models/ApiTypes';
import LadeFortschritt from '../site/LadeFortschritt';
import { RouteComponentProps } from 'react-router-dom';
import { Badge, Table } from 'react-bootstrap';
import { numberformatMoney } from '../../utils/numberformat';

class BelegPositionItem extends React.Component<{position: IRechPos}, {}> {

  render() {
    const { position } = this.props;
    return (
      <tr>
        <td style={{ textAlign: 'left' }}>{position.lfdnr}</td>
        <td style={{ textAlign: 'left' }}>{position.anzahl}</td>
        <td>
          {position.rechnungstext}
          {position.text !== '' && <div>{position.text}</div>}
        </td>
        <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>{numberformatMoney(position.gesamtpreis)} €</td>
      </tr>
    );
  }
}

interface IRechnungDetailsRouterProps {
  renr: string;
}

@observer
export default class BelegDetails extends React.Component<RouteComponentProps<IRechnungDetailsRouterProps>, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @observable rechnung: IRechnung;

  @action setRechnung(rechnung: IRechnung) {
    this.rechnung = rechnung;
  }

  async ladeRechnung() {
    let res = await this.apiStore.rechnungDetail(this.props.match.params.renr);
    if (res.ok) {
      this.setRechnung(res.json);
    }
  }

  componentDidMount() {
    this.ladeRechnung();
  }

  render() {
    const rechnung = this.rechnung;
    if (!rechnung) {
      return <LadeFortschritt/>;
    }

    return (

      <div className="maxwidth">
        <h2>
          {rechnung.art} Nr. {rechnung.renr}
          <Badge className={`rechnung-badge-${rechnung.statustext}`} style={{float: 'right'}}>{rechnung.statustext}</Badge>
        </h2>
        <div>
          Belegdatum: {rechnung.datum} <br />
          {rechnung.refnr && <div>Zu Auftrag: {rechnung.refnr}</div>}
          {rechnung.typtext !== '' && <div>{rechnung.typtext}</div>}
        </div>
        <h2>
          Positionen
        </h2>
        <div>
          <Table striped={true} bordered={false} condensed={true} hover={true}>
            <thead>
              <tr>
                  <th>Pos.</th>
                  <th>Anz.</th>
                  <th>Text.</th>
                  <th>Gesamt</th>
              </tr>
            </thead>
            <tbody>
              {this.rechnung && this.rechnung.positionen.map((position, index) => <BelegPositionItem key={index} position={position}/>)}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4} style={{ textAlign: 'right'}}>
                  <b>Netto</b>: {rechnung.netto && numberformatMoney(rechnung.netto)} €
                </td>
              </tr>
              <tr>
                <td colSpan={4} style={{ textAlign: 'right'}}>
                  <b>Brutto</b>: {rechnung.brutto && numberformatMoney(rechnung.brutto)} €
                </td>
              </tr>
            </tfoot>
          </Table>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/belege/BelegDetails.tsx